<template>
  <div>
    <!--    Cabecera con parte del vídeo-->
    <section class="bg-primary py-5 bg-trama">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 text-white my-5">
            <h1>Esto es… nuestro Templo de Debod</h1>
          </div>

          <div class="col-12">
            <p class="subtitular text-white">
              ¿Quién no ha llevado a su pareja a ver el atardecer desde el Templo de Debod? En la Sierra Norte de Madrid
              también tenemos puestas de sol de película:
              <strong>el cielo, las montañas, tu media naranja y tú, sin nadie más que rompa la magia</strong> del
              momento. ¿No es un sueño? Y si os apetece divertiros entre cabezaditas, os sugerimos algunas actividades
              para hacer hasta que llegue el ocaso.
            </p>
          </div>
          <div class="col-12 mt-4">
            <img src="/img/icons/parejas.svg" alt="Planes especiales para parejas" class="mr-3" /><span
              class="text-black small"
              >Planes especiales para parejas</span
            >
          </div>
        </div>
      </div>
    </section>

    <!--      Fin de cabecera-->
    <!--      Sección con scroll horizontal-->

    <div id="scroll-wrapper" class="container-fluid scroll-wrapper bg-light">
      <div id="scrollContainer" class="scroll-sections">
        <div id="fondo-puntos" style="overflow: hidden;width:50px;position:absolute;height: 100vh;left:70vh">
          <img src="/img/caminos/camino-1.svg" alt="" style="position: absolute;top:30%;z-index:2" />
        </div>

        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <h2 class="mb-4">Planes para todo tipo de parejas</h2>
            <p class="subtitular z-index-up">
              Sabemos que no hay dos parejas iguales. Por eso, ya busquéis actividades para relajaros, aventuras para
              contar a vuestros nietos o simplemente un pequeño escape de la monotonía,
              <strong>en esta ruta encontraréis alguna actividad hecha a vuestra medida.</strong> ¡O podéis animaros a
              hacerlas todas!
            </p>
            <a href="https://www.sierranortemadrid.org/restaurantes/" class="btn btn-primary mr-3 mt-2" target="_blank">
              ¿Dónde comer?
            </a>
            <a href="https://www.sierranortemadrid.org/alojamiento/" class="btn btn-primary mt-2" target="_blank">
              ¿Dónde alojarse?
            </a>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta1/museo-aire-libre-valle.jpg" alt="" class="img-fluid" />
              </div>

              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Museo al Aire Libre del Valle de los Sueños</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <stong>113 obras escultóricas sorprendentes,</stong> en un entorno natural como el de la Sierra
                      del Rincón, declarada en 2005 Reserva de la Biosfera por la Unesco.
                    </span>
                  </li>
                  <li>
                    <span>
                      <a
                        href="http://www.sierradelrincon.org/pdf/Folleto_Senda_115_Valle_de_los_Suenos.pdf"
                        alt="Más información sobre la actividad"
                        target="_blank"
                        >Esta actividad</a
                      >
                      <strong>puede realizarse todos los días, de forma autoguiada.</strong> Para grupos de 10 personas
                      o más, podéis acudir a la oficina de turismo de La Puebla (abierta viernes y sábados de 10 a 19
                      h., y domingos de 10 a 17h.) para que un guía os acompañe.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2h" />
                  <icon-primavera />
                  <icon-culturetas />
                </div>
              </div>
              <!--              Capa visible escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Museo al Aire Libre del Valle de los Sueños</h3>
                <p>¡El mejor plan para las parejas más “artísticas”! Naturaleza, esculturas y un entorno de ensueño.</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal1 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2h" />
                  <icon-primavera />
                  <icon-culturetas />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Inicio "2" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta1/piraguas-buitrago.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Piraguas en Buitrago del Lozoya</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Buitrago del Lozoya está bañado por el río Lozoya y el embalse de Puentes Viejas, por lo que una
                      manera muy original de visitarlo es realizar un
                      <strong
                        ><a
                          href="https://www.sierranortemadrid.org/acuaticas/"
                          target="_blank"
                          alt="Más información sobre la actividad"
                          >recorrido en piragua</a
                        >
                        alrededor de su recinto amurallado.</strong
                      >
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="45m-2h" />
                  <icon-primavera />
                  <icon-verano />
                  <icon-familiar />
                  <icon-aventureros />
                </div>
              </div>
              <!--              Capa visible Escritorio-->

              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Piraguas en Buitrago del Lozoya</h3>
                <p>¿Queréis vivir juntos nuevas aventuras? ¡Recorred en piragua los alrededores de Buitrago!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal2 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="45m-2h" />
                  <icon-primavera />
                  <icon-verano />
                  <icon-familiar />
                  <icon-aventureros />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta1/horcajuela-de-la-sierra.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->

              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Horcajuelo de la Sierra</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/territorio-Sierra-del-Rincon"
                        target="_blank"
                        alt="Más información sobre Horcajuelo de la Sierra"
                        >Uno de los pueblos más pintorescos</a
                      >
                      de los 5 que se ubican en la Sierra del Rincón, junto con Puebla de la Sierra, Prádena del Rincón,
                      Montejo de la Sierra y La Hiruela.
                    </span>
                  </li>
                  <li>
                    <span>
                      Aparte de dar un romántico paseo por su calles de cuento, os recomendamos
                      <strong
                        >visitar la iglesia parroquial de San Nicolás de Bari, el Museo Etnológico, la ermita de Nuestra
                        Señora de los Dolores y el Museo Vargas.</strong
                      >
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3h" />
                  <icon-familias />
                  <icon-culturetas />
                </div>
              </div>
              <!--              Capa visible escritorio-->

              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Horcajuelo de la Sierra</h3>
                <p>Nada despierta el romanticismo como un entorno de cuento. ¡Bienvenidos a Horcajuelo de la Sierra!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal3 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3h" />
                  <icon-familias />
                  <icon-culturetas />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "2" slider ******************-->
        <!--          Inicio "3" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta1/rutas-a-caballo.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Rutas a caballo</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Una de las actividades estrella para realizar en la Sierra Norte de Madrid es dar
                      <a
                        href="https://www.sierranortemadrid.org/montar-a-caballo/"
                        target="_blank"
                        alt="Más información sobre rutas a caballo"
                        >un paseo a caballo</a
                      >
                      por sus hermosos parajes naturales.
                    </span>
                  </li>
                  <li>
                    <span>
                      Tanto si es la primera vez que montas a caballo como si eres todo un experto, encontrarás
                      <strong>rutas adaptadas a tu nivel.</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Podéis realizar esta actividad en muchos puntos de la Sierra Norte de Madrid: La Cabrera,
                      Bustarviejo, Cabanillas de la Sierra, Oteruelo, Navalafuente y Buitrago del Lozoya.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2-3h" />
                  <icon-aventureros />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Rutas a caballo</h3>
                <p>
                  ¿Tenéis en común la afición por el deporte? ¿Y el amor por los animales? ¡Dad rienda suelta a vuestros
                  hobbies!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal4 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2-3h" />
                  <icon-aventureros />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta1/catas-de-vino.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none mb-5">
                <h3 class="mt-5 mb-3">Cata de vinos en Venturada</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¿Buscáis una actividad relajada y divertida? Os invitamos a
                      <strong>visitar un viñedo y su bodega,</strong> para degustar una estupenda
                      <a
                        href="https://www.sierranortemadrid.org/experiencias/07-maridaje-de-vino-y-montana/"
                        target="_blank"
                        alt="Más información sobre cata de vinos"
                        >cata de vinos</a
                      >
                      tintos y blancos.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2-3h" />
                  <icon-foodies />

                  <icon-culturetas />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Cata de vinos en Venturada</h3>
                <p>
                  ¿Buscáis una actividad relajada y, a la par, divertida? ¡Poned a prueba vuestro paladar y vuestro
                  olfato!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal5 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2-3h" />
                  <icon-foodies />

                  <icon-culturetas />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "3" slider ******************-->
      </div>
    </div>
    <!--    Fin sección scroll horizontal-->
    <!--    Inicio modals-->

    <!--   Inicio Modal 1-->
    <b-modal id="modal1" centered scrollable size="lg" hide-footer title="Museo al Aire Libre del Valle de los Sueños">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <stong>113 obras escultóricas sorprendentes,</stong> en un entorno natural como el de la Sierra del
                Rincón, declarada en 2005 Reserva de la Biosfera por la Unesco.
              </span>
            </li>
            <li>
              <span>
                <a
                  href="http://www.sierradelrincon.org/pdf/Folleto_Senda_115_Valle_de_los_Suenos.pdf"
                  alt="Más información sobre la actividad"
                  target="_blank"
                  >Esta actividad</a
                >
                <strong>puede realizarse todos los días, de forma autoguiada.</strong> Para grupos de 10 personas o más,
                podéis acudir a la oficina de turismo de La Puebla (abierta viernes y sábados de 10 a 19 h., y domingos
                de 10 a 17h.) para que un guía os acompañe.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 1-->
    <!--   Inicio Modal 2-->
    <b-modal id="modal2" centered scrollable size="lg" hide-footer title="Piraguas en Buitrago del Lozoya">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Buitrago del Lozoya está bañado por el río Lozoya y el embalse de Puentes Viejas, por lo que una manera
                muy original de visitarlo es realizar un
                <strong
                  ><a
                    href="https://www.sierranortemadrid.org/acuaticas/"
                    target="_blank"
                    alt="Más información sobre la actividad"
                    >recorrido en piragua</a
                  >
                  alrededor de su recinto amurallado.</strong
                >
              </span>
            </li>
            <li>
              <span>
                Duración media: entre 45 minutos y 2 horas.
              </span>
            </li>
            <li>
              <span>
                Esta actividad es ideal para realizarla en primavera y verano.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 2-->
    <!--   Inicio Modal 3-->
    <b-modal id="modal3" centered scrollable size="lg" hide-footer title="Horcajuelo de la Sierra">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/territorio-Sierra-del-Rincon"
                  target="_blank"
                  alt="Más información sobre Horcajuelo de la Sierra"
                  >Uno de los pueblos más pintorescos</a
                >
                de los 5 que se ubican en la Sierra del Rincón, junto con Puebla de la Sierra, Prádena del Rincón,
                Montejo de la Sierra y La Hiruela.
              </span>
            </li>
            <li>
              <span>
                Aparte de dar un romántico paseo por su calles de cuento, os recomendamos
                <strong
                  >visitar la iglesia parroquial de San Nicolás de Bari, el Museo Etnológico, la ermita de Nuestra
                  Señora de los Dolores y el Museo Vargas.</strong
                >
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 3-->
    <!--   Inicio Modal 4-->
    <b-modal id="modal4" centered scrollable size="lg" hide-footer title="Rutas a caballo">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Una de las actividades estrella para realizar en la Sierra Norte de Madrid es dar
                <a
                  href="https://www.sierranortemadrid.org/montar-a-caballo/"
                  target="_blank"
                  alt="Más información sobre rutas a caballo"
                  >un paseo a caballo</a
                >
                por sus hermosos parajes naturales.
              </span>
            </li>
            <li>
              <span>
                Tanto si es la primera vez que montas a caballo como si eres todo un experto, encontrarás
                <strong>rutas adaptadas a tu nivel.</strong>
              </span>
            </li>
            <li>
              <span>
                Podéis realizar esta actividad en muchos puntos de la Sierra Norte de Madrid: La Cabrera, Bustarviejo,
                Cabanillas de la Sierra, Oteruelo, Navalafuente y Buitrago del Lozoya.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 4-->
    <!--   Inicio Modal 5-->
    <b-modal id="modal5" centered scrollable size="lg" hide-footer title="Cata de vinos en Venturada">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¿Buscáis una actividad relajada y divertida? Os invitamos a
                <strong>visitar un viñedo y su bodega,</strong> para degustar una estupenda
                <a
                  href="https://www.sierranortemadrid.org/experiencias/07-maridaje-de-vino-y-montana/"
                  target="_blank"
                  alt="Más información sobre cata de vinos"
                  >cata de vinos</a
                >
                tintos y blancos.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 5-->

    <!--    Fin de modal-->
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  components: {
    IconTime: () => import('../../components/iconos/IconTime'),
    IconCulturetas: () => import('../../components/iconos/IconCulturetas'),
    IconVerano: () => import('../../components/iconos/IconVerano'),
    // IconDistance: () => import('../../components/iconos/IconDistance'),
    IconFamilias: () => import('../../components/iconos/IconFamilias'),
    IconFoodies: () => import('../../components/iconos/IconFoodies'),
    // IconInfluencers: () => import('../../components/iconos/IconInfluencers'),
    // IconInvierno: () => import('../../components/iconos/IconInvierno'),
    // IconOtono: () => import('../../components/iconos/IconOtono'),
    // IconParejas: () => import('../../components/iconos/IconParejas'),
    IconPrimavera: () => import('../../components/iconos/IconPrimavera'),
    // IconTodasEstaciones: () => import('../../components/iconos/IconTodasEstaciones'),
    IconAventureros: () => import('../../components/iconos/IconAventureros')
  },
  mounted() {
    if (window.innerWidth > 1000) {
      const horizontalSlide = new TimelineMax().to('#scrollContainer', 1, { x: '-40%' })
      const scene = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '300%'
        })
        .setPin('#scroll-wrapper')
        .setTween(horizontalSlide)
      const scene2 = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '300%'
        })
        .setTween('#fondo-puntos', {
          width: '50%'
        })

      this.$scrollmagic.addScene(scene)
      this.$scrollmagic.addScene(scene2)
    }
  }
}
</script>
